<div  class="system-shutdown">
    <div class="img">
        <button (click)="goToDashboard()">تخطي</button>
    </div>
</div>
